module.exports = __webpack_public_path__ + "img/badge_gray_spe-beta-v2.5c351e39.svg";